import React from 'react';
import './GetReady.css';
import VisibilitySensor from 'react-visibility-sensor';

const GetReady = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Go-to-market strategy',
                topics: [
                    'Tips & Tricks in finding Problem & Solution fit',
                    'The ultimate list for product manager in-depth interview',
                    'Channels & Loops, Soft vs Regular vs Feature launch, Wrong way to launch',
                ],
            },
            {
                title: 'Experiments',
                topics: [
                    'A/B testing and Advanced testing',
                    'Growth Hacking vs Growth process',
                    'Growth product marketing in 2023',
                    'Metrics that unlock powerful insights',
                ],
            },
            {
                title: 'User Journey',
                topics: [
                    'User Journey Optimization',
                    'Critical user journey',
                    'Casual vs Power users',
                    'How to predict engagement',
                    'AHA/Set up moment case study',
                ],
            },
            {
                title: 'Career',
                topics: [
                    'How to build a Growth Team',
                    'Product Marketing - how to collaborate with PMM or DIY',
                    'How to interview for your Growth Team',
                    'Top 3 PM interview questions that everyone hates and how to crack them',
                    'PM and Sales team collaboration (B2B SaaS)',
                ],
            },
            {
                title: 'Analytics',
                topics: [
                    'User insights for product decisions (Metrics, Growth model, Taxonomy)',
                    'LTV prediction models',
                    'Analytics of the Referral Program',
                    'SQL/Python/R for working with databases',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <p className='getReady_item--title'>{item.title}</p>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li key={`getReady_li-${item + i}`} className='getReady_li'>{item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_arrows'>
            <div className='getReady_wrap black'>
                <div className='container getReady'>
                    <h2 className='getReady_title'>What event <span className='title_gradient'>is</span> about</h2>
                    <div className='getReady_block'>
                        {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetReady;